import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontWeight: theme.typography.fontWeightBold as 'bold',
      color: theme.typography.color?.dark,
      margin: theme.spacing(5, 0, 1),
    },
    subtitle: {
      marginBottom: theme.spacing(-3),
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: '30rem',
      background: theme.palette.common.white,
      borderRadius: theme.spacing(2),
      padding: theme.spacing(5, 10),
    },
    link: {
      marginLeft: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightBold as 'bold',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    logo: {
      maxWidth: '8rem',
    },
  })
);
